import { ResponsiveImageConfiguration } from '../../../lib/graphql/api/graphql';
import getDefaultImageUrls from '../../../lib/getDefaultImageUrls';

const getImageUrlsWithDefaults = (
  originalImageUrls: (string | null | undefined)[],
  imageConfigurations: ResponsiveImageConfiguration[],
) => (originalImageUrls[0]
  ? originalImageUrls
  : getDefaultImageUrls(imageConfigurations));

export default getImageUrlsWithDefaults;
